import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import PhotoGallery from "@/components/base/PhotoGallery";
import { reviewPhotoAlt } from "@/lib/imageAlt";
import type { Testimonial } from "@/mocks/testimonials";

export default function ReviewPhotoWall({ reviews }: { reviews: Testimonial[] }) {
  const photos = reviews.flatMap((item) =>
    item.photos.map((src, index) => ({
      src,
      alt: reviewPhotoAlt(
        item.photoAlts,
        index,
        `${item.name} on the ${item.experience || "farm"} experience in ${item.village || "Konaseema"}`,
      ),
    })),
  );

  return (
    <section className="sun-glaze bg-primary-950 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-30"></div>
      <div className="relative w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
              Visitor Photo Diaries
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50 font-semibold">
            Life, Through Visitor Eyes
          </h2>
          <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed">
            A wall of moments captured by the people who visited — muddy hands, shared meals,
            village walks and quiet mornings in the fields. Tap any photo to open it full screen.
          </p>
        </Reveal>

        <Reveal delay={100}>
          <PhotoGallery images={photos} layout="mosaic" />
        </Reveal>
      </div>
    </section>
  );
}